import openSocket from "socket.io-client";
import { isObject } from "lodash";
import SocketWorker from "./SocketWorker"

export function socketConnection(params) {
  let userId = "";
  let companyId = "";

  if (isObject(params)) {
    // Apóia { user: { companyId, id } } (padrão useAuth)
    if (params.user) {
      companyId = params.user.companyId;
      userId = params.user.id;
    }
    // Apóia { companyId, userId } (legado ou direto)
    else {
      companyId = params.companyId;
      userId = params.userId;
    }
  }

  return SocketWorker(companyId, userId);
}
